import { sanitizePlainText } from "./security";

export const CREATOR_PROJECT_STATUSES = [
  "Idea",
  "Ready",
  "Editing",
  "Review",
  "Done",
];

export function normalizeCreatorProjectStatus(status) {
  return CREATOR_PROJECT_STATUSES.includes(status) ? status : "Idea";
}

export function buildInstructionTemplatePayload(form = {}) {
  return {
    name: sanitizePlainText(form.name, { maxLength: 100 }),
    instructions: sanitizePlainText(form.instructions, { maxLength: 5000 }),
  };
}

export function buildCreatorProjectPayload(form = {}) {
  return {
    title: sanitizePlainText(form.title, { maxLength: 160 }),
    status: normalizeCreatorProjectStatus(form.status),
    notes: sanitizePlainText(form.notes, { maxLength: 5000 }),
    editorName: sanitizePlainText(form.editorName, { maxLength: 100 }),
    editorId: sanitizePlainText(form.editorId, { maxLength: 128 }),
    dueDate: sanitizePlainText(form.dueDate, { maxLength: 10 }),
  };
}

export function isInstructionTemplateValid(payload = {}) {
  return Boolean(payload.name && payload.instructions);
}

export function isCreatorProjectValid(payload = {}) {
  return Boolean(payload.title);
}
